<script lang="ts">
    import { onMount, onDestroy } from "svelte"
    import { eventlocations, eventseries, location, topics } from "../../store"
    import { onNavigate, spaNavigate } from "../../functionTools/routing"
    import { baseURL } from "../../configs/config"
    import { _ } from "svelte-i18n"

    let {
        filterType,
    }: {
        filterType:
            | "typeFilter"
            | "pressnotificationFilter"
            | "topicFilter"
            | "eventseriesFilter"
            | "eventlocationFilter"
            | "vlogFilter"
    } = $props()
    type FilterElement = { id: string; name: string }
    const typeElements: FilterElement[] = [
        { id: "positionArticle", name: $_("general.position") },
        { id: "opinionArticle", name: $_("general.opinion") },
    ]
    const vlogElements: FilterElement[] = [
        { id: "vlog", name: $_("general.vlog") },
    ]
    const pressnotificationElements: FilterElement[] = [
        { id: "withinPress", name: $_("general.inPress") },
        { id: "pressNotification", name: $_("general.pressNotification") },
    ]
    let filterElements: FilterElement[] = $state([])
    let selectedFilters: string[] = $state([])
    let unsubscribeTopics: (() => void) | undefined
    let unsubscribeEventseries: (() => void) | undefined
    let unsubscribeEventlocations: (() => void) | undefined
    const queryKey =
        filterType === "topicFilter"
            ? "filters_topic"
            : filterType == "pressnotificationFilter"
              ? "filters_presstype"
              : filterType == "eventseriesFilter"
                ? "filters_eventseries"
                : filterType == "eventlocationFilter"
                  ? "filters_eventlocation"
                  : filterType == "vlogFilter"
                    ? "filters_vlog"
                    : "filters_type"
    const toggleFilter = (id: string) => {
        if (selectedFilters.includes(id)) selectedFilters = selectedFilters.filter((f) => f !== id)
        else selectedFilters = [...selectedFilters, id]
        updateUrl()
    }

    const updateUrl = () => {
        const url = new URL(window.location.href)
        if (selectedFilters.length > 0) url.searchParams.set(queryKey, selectedFilters.join(","))
        else url.searchParams.delete(queryKey)
        const pathWithQuery = url.pathname + url.search + url.hash
        spaNavigate(pathWithQuery)
    }
    function initFilterGroup(locUrl: string) {
        if (!locUrl.startsWith(baseURL)) {
            locUrl = baseURL + locUrl
        }
        if (filterType === "topicFilter")
            unsubscribeTopics = topics.subscribe((value) => {
                filterElements = Object.values(value).map((topic) => ({
                    id: topic.slug,
                    name: topic.title,
                }))

                // check if already in url
                const url = new URL(locUrl)
                const filtersParam = url.searchParams.get(queryKey)
                if (filtersParam) selectedFilters = filtersParam.split(",").filter((f) => f)
            })
        else if (filterType === "eventseriesFilter") {
            unsubscribeEventseries = eventseries.subscribe((value) => {
                filterElements = Object.values(value).map((eventseries) => ({
                    id: eventseries.slug,
                    name: eventseries.title,
                }))

                // check if already in url
                const url = new URL(locUrl)
                const filtersParam = url.searchParams.get(queryKey)
                if (filtersParam) selectedFilters = filtersParam.split(",").filter((f) => f)
            })
        } else if (filterType === "eventlocationFilter") {
            unsubscribeEventlocations = eventlocations.subscribe((value) => {
                filterElements = Object.values(value).map((eventlocation) => ({
                    id: eventlocation.slug,
                    name: eventlocation.title,
                }))

                const url = new URL(locUrl)
                const filtersParam = url.searchParams.get(queryKey)
                if (filtersParam) selectedFilters = filtersParam.split(",").filter((f) => f)
            })
        } else if (filterType === "pressnotificationFilter") filterElements = pressnotificationElements
        else if (filterType === "vlogFilter") filterElements = vlogElements
        else if (filterType === "typeFilter") filterElements = typeElements
        else filterElements = []

        const url = new URL(locUrl)
        const filtersParam = url.searchParams.get(queryKey)
        if (filtersParam) selectedFilters = filtersParam.split(",").filter((f) => f)
    }
    onMount(() => {
        initFilterGroup($location.url)
        onNavigate(initFilterGroup)
    })

    onDestroy(() => {
        if (unsubscribeTopics) unsubscribeTopics()
        if (unsubscribeEventseries) unsubscribeEventseries()
        if (unsubscribeEventlocations) unsubscribeEventlocations()
    })
</script>

<ul class="filter-group">
    {#each filterElements as filterElement (filterElement.id)}
        <li class="tag big {selectedFilters.includes(filterElement.id) ? 'selected' : ''}">
            <button onclick={() => toggleFilter(filterElement.id)}>
                <span class="text">{filterElement.name}</span>
                <span class="x">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                        <path
                            d="M6.75824 17.2426L12.0009 12M12.0009 12L17.2435 6.75739M12.0009 12L6.75824 6.75739M12.0009 12L17.2435 17.2426"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                    </svg>
                </span>
            </button>
        </li>
    {/each}
</ul>

<style lang="less">
    .filter-group {
        display: flex;
        flex-wrap: wrap;
        gap: 0.6rem;

        li {
            display: flex;
            align-items: center;
            padding: 0px;

            &.selected,
            &:hover {
                color: white;
                background-color: var(--brand-100);
            }

            &.selected {
                .x {
                    display: flex;
                    height: 0.7rem;
                }
            }

            & > button {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 0.2rem 0.9rem;

                transition: padding-right 0.3s ease;
                position: relative;
                transition-delay: 0.2s;
                .x {
                    display: none;
                    align-items: center;
                    position: absolute;
                    right: 0.5rem;
                }

                .text {
                    color: var(--dark-20);
                    text-transform: uppercase;
                    font-weight: 700;
                }
            }

            &.selected > button {
                transition-delay: 0s;
                padding-right: 2rem;
            }

            &.selected > button .x {
                opacity: 0;
                animation: fadeInX 0.2s ease 0.3s forwards;
            }
        }
    }

    @keyframes fadeInX {
        to {
            opacity: 1;
        }
    }
</style>
